export const types = {
    login: '[auth] login',
    logout: '[auth] logout',
    eventosCargados: '[evento] success',
    eventoAgregado: '[evento] add',
    eventoEliminado: '[evento] delete',
    eventoEditado: '[evento] edit',
    token: 'token_organizador'
}